module.exports = __webpack_public_path__ + "img/e844ccd18369c731504c636feba721f.5060d3ae.png";